import { helper } from '@ember/component/helper';

function typeOf([value]: [unknown] /*, hash*/) {
  return typeof value;
}
export default helper(typeOf);
